import c from './index.module.scss'
import {useTranslation} from "react-i18next";
import Links from "components/Links";
import Step1 from "assets/images/stepIcons/step1.svg";
import Step2 from "assets/images/stepIcons/step2.svg";
import Step3 from "assets/images/stepIcons/step3.svg";
import Step4 from "assets/images/stepIcons/step4.svg";

const Footer = () => {
    const { t } = useTranslation();

    const steps = [
        {
            icon: Step1,
        } ,
        {
            icon: Step2,
        },
        {
            icon: Step3,
        },
        {
            icon: Step4,
        },
    ].map((item, index) => {
        return{
            ...item,
            stepCount: t(`steps.step${index+1}Count`),
            stepTitle: t(`steps.step${index+1}Title`),
            stepDesc: t(`steps.step${index+1}Desc`),
        }
    })
    return (
        <footer className={c.manticore_footer}>
            <div className={c.footer_steps}>
                {steps.map(({icon, stepCount, stepDesc, stepTitle, }) => {
                    return(
                        <div className={c.footer_step}>
                            <div className={c.step_icon}>
                                <img src={icon} alt=""/>
                            </div>
                            <div className="step_content">
                                <p className={c.step_count}>
                                    {stepCount}
                                </p>
                                <p className={c.step_title}>
                                    {stepTitle}
                                </p>
                                <p className={c.step_desc}>
                                    {stepDesc}
                                </p>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className={c.footer_links}>
                <Links />
            </div>
        </footer>
    );
};

export default Footer;